<script setup>
import { router, Head, Link, useForm } from '@inertiajs/vue3';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import JetAuditorHeader from '@/Jetstream/AuditorHeader.vue';
import JetApplicationFooter from '@/Jetstream/ApplicationFooter.vue';
import JetWelcomePanel from '@/Jetstream/WelcomePanel.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const navigationSlugs = JSON.stringify(router.page.props.ziggy.navigationSlugs);
const urlNamePrefix = organisation ? "gi." : "";




const form = useForm({
    code: '',
    name: ''
});

const submit = () => {

    let slugs = {'subdomain':'auditor', 'programme': programme.slug};

    if (organisation) {
        slugs.organisation = organisation.slug;
    }

    form.transform(data => ({
        ...data,
        remember: form.remember ? 'on' : '',
        urlNamePrefix: urlNamePrefix,
        subdomain: 'auditor',
    })).post(route(urlNamePrefix+'auditor.login', slugs), {
        onFinish: () => form.reset('code'),
    });
};
</script>

<template>

    <AppTheming />

    <Head title="Log in" />

    <JetAuditorHeader :programme="programme" :organisation="organisation" />

    <div id="content-wrapper">

        <div id="main-content" class="container mx-auto flex flex-col md:flex-row justify-center w-full pt-5 pb-5">

            <div class="card sos-programme-form-card p-10 rounded-2xl w-1/2 mt-48">
                    <!-- <JetValidationErrors class="mb-4" /> -->

                    <div v-if="status" class="mb-4 font-bold">
                        {{ status }}
                    </div>

                    <form @submit.prevent="submit" class="">
                        <div>
                            <JetLabel for="code" :value="$t('auditor.login.code')" />
                            <JetInput
                                id="code"
                                v-model="form.code"
                                type="text"
                                class="mt-1 block w-full"
                                required
                                autofocus
                            />

                            <span v-if="$page.props.errors.code" class="text-danger">{{ $page.props.errors.code[0] }}</span>

                        </div>

                        <div class="mt-4">
                            <JetLabel for="name" :value="$t('auditor.login.name')" />
                            <JetInput
                                id="name"
                                v-model="form.name"
                                type="text"
                                class="mt-1 block w-full"
                                required
                            />
                        </div>

                        <div class="flex items-center justify-end mt-4">
                            <JetButton class="ml-4 whitespace-nowrap" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{$t('dashboard.login.log_in')}}
                            </JetButton>

                        </div>
                    </form>

                </div>

        </div>
    </div>

</template>
